function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-279.000000, -26.000000)",
  fill: "#575756",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(279.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.2371249,1.00940659 L15.9715867,0.0250523825 C15.5081195,-0.0815859902 15.032348,0.160401086 14.8436799,0.595157529 L12.87497,5.18881051 C12.7027079,5.59075514 12.8175493,6.06242487 13.157972,6.33722375 L15.6434683,8.37155579 C14.1669359,11.5173878 11.5871056,14.1341294 8.37564745,15.639371 L6.34131383,13.1538767 C6.06241326,12.8134542 5.59484464,12.6986128 5.19289969,12.8708748 L0.599243145,14.8395832 C0.160384885,15.0323526 -0.0816023796,15.5081238 0.025036076,15.9715906 L1.00939105,20.2371255 C1.11192803,20.6800849 1.50567002,21 1.96913715,21 C12.473025,21 21,12.4894376 21,1.96915195 C21,1.50978665 20.6841861,1.11194349 20.2371249,1.00940659 Z"
})))));

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Phone Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d64643ee.svg";
export { ForwardRef as ReactComponent };